import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  uploadEncodedFile,
} from "NetworkCall";
import {
  APP_API_KEY,
  INSTANCE_URL,
  BASE_IMAGES_URL,
  itemCount,
} from "Constants";
import { randomstring } from "randomstring-js";
import _ from "lodash";
import { fetchEventDetails } from "DashboardUserAction";

export var FETCH_TEMPLATE = "fetch_template";
export var FETCH_APPSTORE_DETAILS = "FETCH_APPSTORE_DETAILS";
export var UPDATE_APPSTORE_LOGO_LOCALLY = "UPDATE_APPSTORE_LOGO_LOCALLY";
export var UPDATE_APPSTORE_OTHERIMAGES = "UPDATE_APPSTORE_OTHERIMAGES";
export var FETCH_EMAIL_LOG = "FETCH_EMAIL_LOG";
export var BILLING_ACTIVEUSER_LIST = "BILLING_ACTIVEUSER_LIST";
export var FETCH_EMAIL_LOG_CONTENTS = "FETCH_EMAIL_LOG_CONTENTS";
export var LANGUAGE_ADD_MODAL = "LANGUAGE_ADD_MODAL";
export var FETCH_EVENT_LANGUAGE = "FETCH_EVENT_LANGUAGE";
export var LANGUAGE_CSV_IMPORT_MODAL = "LANGUAGE_CSV_IMPORT_MODAL";
export var INTEGRATION_MODAL = "INTEGRATION_MODAL";
export var FETCH_ALL_EMAIL_LOG = "FETCH_ALL_EMAIL_LOG";

export function changePassword(session, values, callback) {
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/user/password?reset=true&login=true`;
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        var returnData = { error: 0, data: "Password changed successfully!" };
        callback(returnData);
      },
      (error) => {
        var returnData = { error: 1, data: error.message };
        callback(returnData);
      }
    );
  };
}

export function fetchTemplate(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/email_templates?filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_TEMPLATE, payload: data });
      },
      (error) => {}
    );
  };
}

export function addTemplate(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/email_templates`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchTemplate(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateTemplate(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/email_templates`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchTemplate(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function validateSMTP(session, values, callback) {
  var urlMail = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    var postData = {
      host: values.host,
      port: values.port,
      username: values.user,
      password: values.password,
      receiver_email: values.receiver_email ? values.receiver_email : "",
      test_email_smtp: values.test_email_smtp ? values.test_email_smtp : false,
      fromemail: values.fromemail,
      type: "validatesmtp",
    };
    postRequest(
      urlMail,
      postData,
      session,
      dispatch,
      (valid) => {
        callback({ ...valid });
      },
      (error) => {}
    );
  };
}

export function fetchappstoreDetails(session, clientid) {
  var optionalFilter = `include_count=true&limit=1&order=appstoreid%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_appstore_details?filter=clientid=${clientid}&${optionalFilter}`;
  var otherimages = [
    { position: 0, image: "" },
    { position: 1, image: "" },
    { position: 2, image: "" },
    { position: 3, image: "" },
    { position: 4, image: "" },
  ];

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_APPSTORE_DETAILS, payload: data });
        dispatch({
          type: UPDATE_APPSTORE_OTHERIMAGES,
          payload: data.resource[0].otherimages
            ? JSON.parse(data.resource[0].otherimages)
            : otherimages,
        });
      },
      (error) => {}
    );
  };
}

export function updateAppstoreLogoLocally(image) {
  return (dispatch) => {
    dispatch({ type: UPDATE_APPSTORE_LOGO_LOCALLY, payload: image });
  };
}

export function updateAppstoreOtherImages(images) {
  return (dispatch) => {
    dispatch({ type: UPDATE_APPSTORE_OTHERIMAGES, payload: images });
  };
}

export function addAppstoreData(
  session,
  data,
  imageUploaded,
  otherImagesUploaded,
  clientid,
  coverimageUploaded,
  callback
) {
  var applogo = data.applogo ? data.applogo : "";

  var n = applogo.search(";base64,");
  // var otherimages = [];
  // _.map(data.otherimages, (item, index) => {
  //   if (item && item.image) {
  //     otherimages.push(item);
  //   }
  // });
  // console.log("otherimages", otherimages);
  var otherimages = data.otherimages ? JSON.parse(data.otherimages) : "";

  var coverimage = data.coverimage ? data.coverimage : "";

  var coverpos = coverimage.search(";base64,");

  return (dispatch) => {
    if (
      n > 0 &&
      imageUploaded &&
      otherImagesUploaded &&
      coverpos > 0 &&
      coverimageUploaded
    ) {
      uploadAppstoreLogo(session, applogo, clientid, dispatch, (dataicon) => {
        uploadAppstoreCoverImage(
          session,
          coverimage,
          clientid,
          dispatch,
          (datacover) => {
            uploadAppstoreOtherImages(
              session,
              otherimages,
              clientid,
              dispatch,
              (dataimages) => {
                var resourcedata = {
                  ...data,
                  applogo: dataicon.name,
                  coverimage: datacover.name,
                  otherimages: JSON.stringify(dataimages.images),
                };

                insertIntoAppstore(session, resourcedata, dispatch, callback);
              }
            );
          }
        );
      });
    } else if (
      otherImagesUploaded &&
      n < 0 &&
      !imageUploaded &&
      coverpos > 0 &&
      coverimageUploaded
    ) {
      uploadAppstoreCoverImage(
        session,
        coverimage,
        clientid,
        dispatch,
        (datacover) => {
          uploadAppstoreOtherImages(
            session,
            otherimages,
            clientid,
            dispatch,
            (dataimages) => {
              var resourcedata = {
                ...data,
                coverimage: datacover.name,
                otherimages: JSON.stringify(dataimages.images),
              };

              insertIntoAppstore(session, resourcedata, dispatch, callback);
            }
          );
        }
      );
    } else if (
      n > 0 &&
      imageUploaded &&
      !otherImagesUploaded &&
      coverpos > 0 &&
      coverimageUploaded
    ) {
      uploadAppstoreLogo(session, applogo, clientid, dispatch, (dataicon) => {
        uploadAppstoreCoverImage(
          session,
          coverimage,
          clientid,
          dispatch,
          (datacover) => {
            var resourcedata = {
              ...data,
              applogo: dataicon.name,
              coverimage: datacover.name,
            };
            insertIntoAppstore(session, resourcedata, dispatch, callback);
          }
        );
      });
    } else if (n > 0 && imageUploaded && coverpos < 0 && !coverimageUploaded) {
      uploadAppstoreLogo(session, applogo, clientid, dispatch, (dataicon) => {
        var resourcedata = {
          ...data,
          applogo: dataicon.name,
        };
        insertIntoAppstore(session, resourcedata, dispatch, callback);
      });
    } else {
      var resourcedata = { ...data };
      insertIntoAppstore(session, resourcedata, dispatch, callback);
    }
  };
}

export function updateAppstoreData(
  session,
  data,
  imageUploaded,
  otherImagesUploaded,
  callback
) {
  // debugger;

  var applogo = data.applogo ? data.applogo : "";
  var otherimages = JSON.parse(data.otherimages);

  var n = applogo.search(";base64,");

  return (dispatch) => {
    if (n > 0 && imageUploaded && otherImagesUploaded) {
      uploadAppstoreLogo(session, applogo, dispatch, (dataicon) => {
        uploadAppstoreOtherImages(
          session,
          otherimages,
          dispatch,
          (dataimages) => {
            var resourcedata = {
              ...data,
              applogo: dataicon.name,
              otherimages: JSON.stringify(dataimages.images),
            };

            updateAppstore(session, resourcedata, dispatch, callback);
          }
        );
      });
    } else if (otherImagesUploaded) {
      uploadAppstoreOtherImages(
        session,
        otherimages,
        dispatch,
        (dataimages) => {
          var resourcedata = {
            ...data,
            otherimages: JSON.stringify(dataimages.images),
          };

          updateAppstore(session, resourcedata, dispatch, callback);
        }
      );
    } else if (n > 0 && imageUploaded) {
      uploadAppstoreLogo(session, applogo, dispatch, (dataicon) => {
        var resourcedata = { ...data, applogo: dataicon.name };
        updateAppstore(session, resourcedata, dispatch, callback);
      });
    } else {
      var resourcedata = _.omit(data, ["applogo", "otherimages"]);
      updateAppstore(session, resourcedata, dispatch, callback);
    }
  };
}

export function uploadAppstoreLogo(
  session,
  image,
  clientid,
  dispatch,
  callback
) {
  var eventid = session.eventid;
  image = image.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `clients/${clientid}/appstore/logo/${randomstring(32)}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: image,
      },
    ],
  };
  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback(data);
    },
    (error) => {
      callback({ success: 2, message: error });
    }
  );
}

export function uploadAppstoreOtherImages(
  session,
  images,
  clientid,
  dispatch,
  callback
) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(images, (img, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var image = img.image;
        var n = image.search(";base64,");
        if (n > 0) {
          image = image.replace(/^data:image\/[a-z]+;base64,/, "");
          var filename = `clients/${clientid}/appstore/images/${randomstring(
            32
          )}.jpg`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: image,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              images[index].image = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (image == "") {
          images[index].image = "";
          resolve();
        } else {
          images[index].image = image;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback({ images: images });
  });
}

export function uploadAppstoreCoverImage(
  session,
  image,
  clientid,
  dispatch,
  callback
) {
  image = image.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `clients/${clientid}/appstore/coverimage/${randomstring(
    32
  )}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: image,
      },
    ],
  };
  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback(data);
    },
    (error) => {
      callback({ success: 2, message: error });
    }
  );
}

export function insertIntoAppstore(session, data, dispatch, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_appstore_details`;
  var body = { resource: { ...data } };

  var urlMail = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  postRequest(
    url,
    body,
    session,
    dispatch,
    (responsedata) => {
      var id = responsedata.resource[0].appstoreid;
      var postData = {
        appstoreid: id,
        //   clientid: data.clientid,
        type: "sentApstoreEmail",
      };
      postRequest(
        urlMail,
        postData,
        session,
        dispatch,
        (email) => {
          dispatch(fetchappstoreDetails(session, data.clientid));
          callback({ success: 1 });
        },
        (error1) => {}
      );
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function updateAppstore(session, data, dispatch, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_appstore_details`;
  var body = { resource: { ...data, eventid: session.eventid } };

  var urlMail = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  patchRequest(
    url,
    body,
    session,
    dispatch,
    (responsedata) => {
      var id = responsedata.resource[0].appstoreid;
      var postData = {
        appstoreid: id,
        eventid: session.eventid,
        type: "sentApstoreEmail",
      };
      postRequest(
        urlMail,
        postData,
        session,
        dispatch,
        (email) => {
          dispatch(fetchappstoreDetails(session));
          callback({ success: 1 });
        },
        (error1) => {}
      );
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function fetchEmailLog(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_email_logs?fields=logid,eventid,log_from, timestamp,email_status,reason,recipients&include_count=true&filter=eventid=${session.eventid}&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        // dispatch({type:FETCH_EMAIL_LOG, payload:data});
        dispatch({
          type: FETCH_EMAIL_LOG,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchEmailLogContent(session, logid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_email_logs?fields=content&include_count=true&filter=logid=${logid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_EMAIL_LOG_CONTENTS,
          payload: { data: data.resource[0].content, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function sortEmailLogByStatus(
  session,
  sort = "all",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  var sortQuery = `email_status=${sort}`;

  var filter = encodeURI(
    `(eventid=${session.eventid})` + (sort === "all" ? "" : `AND(${sortQuery})`)
  );

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_email_logs?fields=logid,eventid,log_from, timestamp,email_status,reason,recipients&include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: FETCH_EMAIL_LOG,
          payload: { data: response.resource, count: response.meta.count },
        });

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function searchEmailLogs(session, search = "", pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var searchQuery = `(recipients like %${search}%)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_email_logs?fields=logid,eventid,log_from, timestamp,email_status,reason,recipients&include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_EMAIL_LOG,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function updateTimeZone(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event`;
  var data = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updatedEventSetting(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings`;
  var data = { resource: { ...values } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeSpeakerSort(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, speakersort: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeSponsorSort(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, sponsorsort: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeExhibitorSort(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, exhibitorsort: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeGalleryUploadPermission(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, galleryimage: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeNotificationStatus(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, notificationonticketpurchase: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeAppBottomMenuStatus(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, isbottommenuactive: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeSocialLogin(session, option, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${session.eventid}`;
  let data = { resource: { eventid: session.eventid, sociallogin: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeAutologinStatus(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings`;
  var data = {
    resource: { id: id, autologin: option, eventid: session.eventid },
  };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeloginMandatoryStatus(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, isloginmandatory: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
export function changeWaitlistmode(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, waitlistmode: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
export function changeScheduleview(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, scheduleview: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeMultipleLoginStatus(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, allowmultiplelogin: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateEventSettingOption(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { ...values } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

/*** Get Billing Details ***/
export function fetchDownloadBillingInfo(session, object, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var body = {
    session: session,
    eventid: session.eventid,
    type: "downloaddetailsinfo",
    fromdt: object.fromdt,
    todt: object.todt,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

/*** ACTIVE USER LIST ***/
export function fetchBillingInfo(
  session,
  pageCount = 0,
  countPerPage = 0,
  fromdt,
  todt,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    postRequest(
      url,
      {
        session: session,
        eventid: session.eventid,
        limit: itemCount,
        offset: offset,
        fromdt: fromdt,
        todt: todt,
        type: "detailsinfotable",
      },
      session,
      dispatch,
      (response) => {
        if (response.bilingactiveuserinfo.length === 0) {
          dispatch({
            type: BILLING_ACTIVEUSER_LIST,
            payload: { data: {}, count: 0 },
          });
        } else {
          dispatch({
            type: BILLING_ACTIVEUSER_LIST,
            payload: {
              data: response.bilingactiveuserinfo,
              count: response.count,
            },
          });
        }

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}
export function changeUserfilesdownloadable(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, userfilesdownloadable: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
export function changeSpeakerfilesdownloadable(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, speakerfilesdownloadable: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function changeSponsorfilesdownloadable(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, sponsorfilesdownloadable: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
export function changeExhibitorfilesdownloadable(
  session,
  option,
  id,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, exhibitorfilesdownloadable: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
export function changeSessionfilesdownloadable(session, option, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var data = { resource: { id: id, sessionfilesdownloadable: option } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function resetTemplate(session, template, column, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/reseteventTemplate`;
  var body = {
    eventid: session.eventid,
    template_name: template,
    column_name: column,
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchTemplate(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openLanguageAddModal(showModal) {
  return { type: LANGUAGE_ADD_MODAL, payload: showModal };
}

export function openLanguageCsvImportModal(showModal) {
  return { type: LANGUAGE_CSV_IMPORT_MODAL, payload: showModal };
}

export function fetchEventLanguages(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventlanguages?filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_EVENT_LANGUAGE, payload: data.resource });
        callback({ success: 1, data: data.resource });
      },
      (error) => {}
    );
  };
}

export function checkLanguageExistEventwise(session, lang, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventlanguages?filter=((eventid=${session.eventid})AND(languagekey=${lang}))`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 0 });
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {}
    );
  };
}

export function addEventLanguage(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventlanguages`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        //dispatch(fetchEventLanguages(session));
        callback({ success: 1, id: response.resource[0].id });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateEventLanguage(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventlanguages`;
  var body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openIntegrationModal(payload) {
  return { type: INTEGRATION_MODAL, payload: payload };
}

export function fetchAllEmailLog(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_email_logs?fields=logid,eventid,log_from, timestamp,email_status,reason,recipients&filter=eventid=${session.eventid}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        // dispatch({type:FETCH_EMAIL_LOG, payload:data});
        dispatch({
          type: FETCH_ALL_EMAIL_LOG,
          payload: { data: data.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export const updateUserEventEmbedJson = (
  session,
  settingsId,
  value,
  callback
) => {
  let fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(id=${settingsId}))`
  );
  let patchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=${fetchFilter}`;

  let patchBody = {
    resource: { widget_json: JSON.stringify(value) },
  };

  return (dispatch) => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      (res) => {
        callback({ success: 1 });
        dispatch(fetchEventDetails(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
};
